import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function Video(){
    return(
        <>
        <Header></Header>
        <h3 className="ndf cmgs">coming soon...</h3>
        <Footer></Footer>
        </>
    )
};
export default Video